import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space, layout } from 'styled-system';
import { useSelector } from 'react-redux';
import Card from 'theme/card';
import Text from 'theme/text';
import Lock from 'theme/icons/lock';
import translations from 'translations';

const Inner = styled.div`
  ${space}
  ${layout}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${themeGet('colors.grey_200')};
`;

function LockedSection({ width, minHeight = '120px', message, style }) {
  const { languageCode } = useSelector((state) => state.config);

  return (
    <Card
      width={width || '100%'}
      bg="grey_100"
      borderColor="primary_200"
      py="m"
      px="s"
      {...style}
    >
      <Inner minHeight={minHeight} px="s">
        <Lock width="28" />
        <Text
          fontSize={['pSmall', 'pSmall', 'pSmall', 'pLarge']}
          lineHeight={['pSmall', 'pSmall', 'pSmall', 'pLarge']}
          fontWeight="medium"
          color="grey_400"
          mt="xs"
        >
          {message || translations[languageCode]['insufficient permissions']}
        </Text>
      </Inner>
    </Card>
  );
}

export default LockedSection;
